module.exports = __webpack_public_path__ + "img/data-compression.d5d3b0cc.png";